/* @flow */
import React from 'react';

import AlertDialog from 'components/AlertDialog.jsx';
import Dialog from 'components/Dialog.jsx';
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import RelationshipActions from 'actions/RelationshipActions';
import RelationshipStore from 'stores/RelationshipStore';
import RelationshipView from 'user/components/RelationshipView.jsx';

const RelationshipModal = React.createClass({
  propTypes: {
    userId: React.PropTypes.number.isRequired,
    onRequestHide: React.PropTypes.func,
    groupToAdmin: React.PropTypes.instanceOf(Group),
    groupMember: React.PropTypes.instanceOf(GroupMembership),
  },

  mixins: [
    linkStateWithStores([RelationshipStore]),
  ],

  statics: {
    prefetch: [
      function(props) {
        const relatedUser = RelationshipStore.getRelationship(props.userId);
        if (!relatedUser || !relatedUser.hasSubscriptions()) {
          return RelationshipActions.loadRelationship(props.userId);
        }
        return null;
      },
    ],
    prefetchErrorModal() {
      return (
        <AlertDialog
          title="An error occurred."
          subtext={`
            We were unable to display this profile because
            you are no longer connected to the user.
          `}
          buttonText="Close"
        />
      );
    },
  },

  getDefaultProps() {
    return {
      onRequestHide: () => {},
    };
  },

  getInitialState() {
    return this.getStateFromStores();
  },

  getStateFromStores() {
    const relationship = RelationshipStore.getRelationship(this.props.userId);

    return {
      relationship,
    };
  },

  render() {
    return (
      <Dialog
        eventScreenName="RelationshipModal"
        {...this.props}
        className="RelationshipModal">
        <RelationshipView
          groupToAdmin={this.props.groupToAdmin}
          groupMember={this.props.groupMember}
          onRequestHide={this.props.onRequestHide}
          relationship={this.state.relationship}
        />
      </Dialog>
    );
  },
});

export default RelationshipModal;



// WEBPACK FOOTER //
// ./src/user/components/RelationshipModal.jsx